import { Component, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { ProductTreeGroupNode, ProductTreePath } from '@forgerock/backstage-ui-core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { TreeComponent } from '../../input/tree/tree.component';
import { TreeNode } from '../../model/tree-node';
import { SearchProductTreeService } from '../../search-product-tree.service';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';

@Component({
  selector: 'app-search-filter-product',
  templateUrl: './search-filter-product.component.html',
  styleUrls: [ './search-filter-product.component.scss' ],
  imports: [ TreeComponent ]
})
export class SearchFilterProductComponent implements OnInit, OnDestroy {
  private productTreeService = inject(SearchProductTreeService);
  private container = inject(SearchParamsContainerComponent);

  @Output() visible = new BehaviorSubject<boolean>(false)

  eosl = false;
  tree: TreeNode<Partial<ProductTreeGroupNode>>[] = [];
  selectedNodes: string[] = [];

  private subscription: Subscription;

  async ngOnInit(): Promise<void> {
    this.subscription = this.container.paramsChange.subscribe({
      next: async params => {
        this.eosl = params.eosl;
        this.tree = await this.productTreeService.getTree(this.eosl);
        this.selectedNodes = this.getIdOfSelectedNodes(params.productVersionPath);
        this.visible.next(!!this.tree.length && params.tab.params.includes('productVersionPath'));
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  selectNode(item: TreeNode<ProductTreeGroupNode>) {
    // If a product was selected then use the latest minor version
    const { id } = this.productTreeService.getLatestVersion(item);
    const path = ProductTreePath.parse(id);
    this.selectedNodes = [ ...this.selectedNodes, ...path.toPartialPaths() ];
    this.container.setParams({ productVersionPath: [ ...this.container.params.productVersionPath, path ] });
  }

  deselectNode(item: TreeNode<ProductTreeGroupNode>) {
    const paths = this.container.params.productVersionPath.filter(path => !path.toString().startsWith(item.id));
    this.container.setParams({ productVersionPath: paths });
  }

  async toggleEosl() {
    this.eosl = !this.eosl;
    this.tree = await this.productTreeService.getTree(this.eosl);
    this.container.setParams({ eosl: this.eosl });
  }

  getIdOfSelectedNodes(paths: ProductTreePath[]): string[] {
    return paths.flatMap(path => path.toPartialPaths());
  }
}
